import { DeviceSelectionCategoryCoCo } from '../enums.js';

// GET /deviceVariants/{deviceType} requires a category, so the catalogue is fetched one category at a time
export const DEVICE_VARIANT_CATEGORIES: DeviceSelectionCategoryCoCo[] = [
  DeviceSelectionCategoryCoCo.PHONES,
  DeviceSelectionCategoryCoCo.TABLETS,
  DeviceSelectionCategoryCoCo.COMPUTERS,
  DeviceSelectionCategoryCoCo.OTHER_DEVICES,
  DeviceSelectionCategoryCoCo.ACCESSORIES,
];

// Accessories and other devices only groups devices in EPP selections, the catalogue has them as other devices
export const toDeviceVariantCategoryQuery = (category: DeviceSelectionCategoryCoCo): string =>
  (category === DeviceSelectionCategoryCoCo.ACCESSORIES_AND_OTHER_DEVICES
    ? DeviceSelectionCategoryCoCo.OTHER_DEVICES
    : category
  ).toLowerCase();
